// Official brand logo (Everyone's Budget)
export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_personal-finance-323/artifacts/qnnbblee_IMG-20260830-WA0000.jpg";

// GST/HST business number (shown on receipts)
export const BUSINESS_NUMBER = "79417 6974";
